import { render, staticRenderFns } from "./DataLayout.vue?vue&type=template&id=1ab6c797&scoped=true&"
import script from "./DataLayout.vue?vue&type=script&lang=js&"
export * from "./DataLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab6c797",
  null
  
)

export default component.exports